
import {
  defineComponent, onMounted, ref, watch,
} from 'vue';

import { Tooltip, } from 'ant-design-vue';

import gridDetailVue from './gridDetail.vue';
import moment from 'moment';

export default defineComponent({
  components: {
    gridDetailVue,
    Tooltip,
  },
  props: {
    gridDetailData: {
      type: Object,
      default: () => ({}),
      require: true,
    },
    activeGrid: {
      type: Object,
      default: () => ({}),
      require: true,
    },
    activeGridIndex: {
      type: Number,
      default: -1,
      require: true,
    },
  },
  setup (props,{ emit, expose, }) {
    // 网格详情数据
    const gridDataList = ref<any>(null);

    // 是否允许自动滚动
    const isScroll = ref<boolean>(true);

    /**
     * @name:关闭右侧面板
     * @msg:
     * @return {*}
     */
    const closeRightPanel = () => {
      emit('closeRightPanel');
    };

    /**
     * @name: 点击选中某个网格
     * @param null
     * @return {void}
     */
    const clickGridChecked = (index:number,checkedGrid:Record<string, unknown>) => {
      emit('gridDetailClick', { index, checkedGrid, });
      isScroll.value = false;

      setTimeout(() => {
        isScroll.value = true;
      }, 500);
    };

    const tabClick = (activeTab: number) => {
      emit('tabClick', activeTab);
    };

    // 更新左侧逐时列表
    const updateLeftTable = () => {
      emit('updateLeftTable');
    };
    // 更新工单详情
    const updateTicketDetail = () => {
      emit('updateTicketDetail');
    };

    const gridContentRef = ref();

    const scroll = (top: number) => {
      if (!top && top !== 0) return;
      if (gridContentRef.value) {
        gridContentRef.value.scrollTo({
          top,
          behavior: 'smooth',
        });
      }
    };

    watch(() => props.gridDetailData, (val) => {
      gridDataList.value = val;
    },{
      deep: true,
    });

    expose({
      isScroll,
      scroll,
    });

    return {
      gridDataList,
      closeRightPanel,
      clickGridChecked,
      moment,
      gridContentRef,
      tabClick,
      updateLeftTable,
      updateTicketDetail,
    };
  },
});
